import { Breadcrumb } from 'antd'
import { CButton } from 'app/components/Common'
import { COLORS } from 'app/constants'
import { useUserList } from 'app/hooks/trade/userList'
import { useUserSocket } from 'app/hooks/trade/userSocket'
import React, { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

const AdminBreadcrumb = ({ items }) => {
	const location = useLocation()
	const navigation = useHistory()

	const socket = useUserSocket()

	const { userlist, sendwho } = useUserList()

	useEffect(() => {
		sendwho()
	}, [])

	return (
		<Breadcrumb
			itemRender={route => {
				let usersLink =
					location.pathname === '/users'
						? '/users/0'
						: location.pathname

				const isActive = route.link === usersLink

				return (
					<CButton
						title={
							route.title +
							(route.title == '접속자수'
								? `(${userlist?.length || 0})`
								: '')
						}
						onClick={() => {
							navigation.push(route.link)
						}}
						style={{
							color: isActive ? COLORS.secondary : '#444',
							fontWeight: isActive ? '600' : '400',
						}}
					/>
				)
			}}
			items={items}
		/>
	)
}

export default React.memo(AdminBreadcrumb)
